import { errorHandler } from "./errorHandler";
import { GetUser } from "../interface";
import { apiRequest } from "./apiRequest";

export const getUser = async (
  page: number,
  limit: number,
  search: string = ""
): Promise<GetUser> => {
  try {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });

    if (search.trim()) {
      params.append("search", search.trim());
    }

    return await apiRequest<GetUser>("get", "/users", { params });
  } catch (error) {
    errorHandler(error);
    throw new Error("Failed to fetch users");
  }
};
